function padTimePart(value) {
  return String(value).padStart(2, '0')
}

export function buildTrajectoryExportFileName(plateNumber, exportedAt = new Date()) {
  const plate = String(plateNumber == null ? '' : plateNumber).trim() || '未知车牌'
  const safePlate = plate.replace(/[\\/:*?"<>|]/g, '_')
  const timestamp = [
    exportedAt.getFullYear(),
    padTimePart(exportedAt.getMonth() + 1),
    padTimePart(exportedAt.getDate()),
    padTimePart(exportedAt.getHours()),
    padTimePart(exportedAt.getMinutes()),
    padTimePart(exportedAt.getSeconds())
  ].join('')

  return `${safePlate}_${timestamp}.xlsx`
}
